<template>
  <div class="section background">
    <div class="layout-content">
      <SubTitle :text="data.titleCh" :subText="data.titleEn"/>

      <!-- 培训视频 -->
      <div v-for="(item, index) in data.content" :key="index">

        <div class="train-title">
          <SubTitle v-if="item.title" :text="item.title" :subText="item.title"/>
        </div>

        <List
            :data="item"
            :isBtn="false"
        />

      </div>

      <!-- 活动视频 -->
      <TriningList
          :data="data"
      />
    </div>
  </div>
</template>

<script>
import SubTitle from '@/components/SubTitle.vue'
import TriningList from '@/components/TrainingList.vue'
import List from '@/components/videoList.vue'

import {mapState} from 'vuex'

import VueTypes from 'vue-types'

export default {
  components: {
    SubTitle,
    List,
    TriningList
  },
  props: {
    data: VueTypes.object.def({})
  },
  data() {
    return {}
  },
  computed: {
    ...mapState(['isMobile'])
  }
}
</script>

<style lang="scss" scoped>

.background {
  background: #F5F7F8;
}

.train-title {
  margin: 20px 0 30px;

  @include mobile {
    margin: 0 0 12px;
  }
}

.train-text {
  color: #000000;
  font-size: 24px;
  font-family: Alibaba-PuHuiTi-Heavy;
  line-height: 33px;

  @include mobile {
    font-size: 16px;
    line-height: 22px;
  }
}
</style>
